export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  // Внешние партнёры (23.10.2026): своя страница и вход по ссылке-приглашению.
  PARTNER: '/partner',
  PARTNER_JOIN: '/partner/join',
  CONNECT_INSTAGRAM: '/connect-instagram',

  // ── Аккаунты ─────────────────────────────────────────────
  ACCOUNTS: '/accounts',
  ACCOUNT_DETAIL: '/accounts/:id',
  // Вкладка «Шаблоны оформления» внутри раздела «Аккаунты»
  ACCOUNTS_TEMPLATES: '/accounts?tab=templates',

  TEMPLATES: '/templates',
  TEMPLATE_NEW: '/templates/new',
  TEMPLATE_EDIT: '/templates/:id/edit',

  // ── Публикации ───────────────────────────────────────────
  PUBLICATIONS: '/publications',
  // Единый экран создания: формат выбирается сегментированным переключателем
  PUBLICATION_NEW: '/publications/new',
  PUBLICATION_DETAIL: '/publications/:id',
  ALL_PUBLICATIONS: '/all-publications',
  ALL_PUBLICATION_DETAIL: '/all-publications/:mediaId',

  // Прежние адреса создания — остаются как редиректы на PUBLICATION_NEW
  POSTS_CREATE: '/posts/create',
  REELS: '/reels',

  // ── Статистика ───────────────────────────────────────────
  STATS: '/stats',
  STATS_ACCOUNTS: '/stats/accounts',
  STATS_LINKS: '/stats/links',
  STATS_AVERAGES: '/stats/averages',
  STATS_TIMELINE: '/stats/timeline',
  /** Результаты партнёров: публикации и просмотры подключённых ими аккаунтов. */
  STATS_PARTNERS: '/stats/partners',
  // Конструктор выгрузок — отдельный экран, открывается из «Статистики»
  STATS_REPORT: '/stats/report',

  ANALYTICS_ACCOUNT: '/analytics/account/:accountId',

  // Прежние адреса статистики — редиректы
  ACCOUNTS_STATS: '/accounts-stats',
  ANALYTICS: '/analytics',
  STATS_HISTORY: '/stats-history',
  HARVEST: '/harvest',
  /** Разбор комментариев под нашими публикациями — вкладка «Публикаций». */
  PUBLICATIONS_COMMENTS: '/publications/comments',
  /** Прежний адрес разбора — редирект на вкладку. */
  COMMENTS: '/comments',
  DASHBOARD: '/dashboard',

  // ── Конвейер контента ────────────────────────────────────
  MY_DAY: '/my-day',
  MODERATION: '/moderation',
  CONTENT_TASKS: '/content',
  CONTENT_REVIEW: '/content/review',
  CONTENT_PUBLISH: '/content/publish',
  HEAD_TODAY: '/today',
  DIVISION: '/division',
  HEAD_WEEK: '/week',

  // ── Монтаж (прототип montage-funnel) ─────────────────────
  /** Постановщик: доска задач монтажёрам. */
  MONTAGE: '/montage',
  /** Постановщик: календарь отдела по монтажёрам. */
  MONTAGE_CALENDAR: '/montage/calendar',
  /** Руководитель: темы отдела и что по ним вышло. */
  MONTAGE_TOPICS: '/topics',
  /** Видео, сделанные людьми, с цифрами постов. */
  VIDEOS: '/videos',
  /** Монтажёр: свои задачи. */
  MY_TASKS: '/my-tasks',
  /** Монтажёр: недельный календарь своих задач. */
  MY_TASKS_CALENDAR: '/my-tasks/calendar',
  /** Монтажёр: посты аккаунтов направления — приложить ссылку от поста. */
  MY_TASKS_POSTS: '/my-tasks/posts',
  /** Другой отдел (Редакция) берёт вышедшие ролики B2G в свои паблики. */
  TAKES: '/takes',
  /** «Отработано»: учёт материалов раздающего (Саяна) и отчёт руководителю. */
  WORK: '/work',

  // ── Личный кабинет ───────────────────────────────────────
  PROFILE: '/profile',
  /** Витрина компонентов, только тестовый стенд. */
  UI_KIT: '/ui-kit',

  // ── Сотрудники и доступы ─────────────────────────────────
  TEAM: '/team',
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_ASSIGNMENTS: '/admin/assignments',
} as const;

/**
 * Разделы меню. Единый источник для сайдбара и мобильного таб-бара.
 *
 * `roles` — роли в отделении, которым раздел нужен. Пусто — раздел про аккаунты
 * сети, и он не про конвейер вовсе.
 *
 * Набор у каждой роли свой не ради красоты. Монтажёру не нужна модерация,
 * модератору — публикация, а руководителю — чужой дневной план: у каждого
 * из них один экран, на котором проходит весь день, и лишние пункты меню
 * только отвлекают от него.
 */
export const NAV_SECTIONS = [
  // По README прототипа «Монтажа»: у постановщика — «Монтаж», у монтажёра — «Мои
  // задачи». Прежние экраны конвейера («Мой день», «Задачи», «Проверка»,
  // «Публикация», «Сегодня», «Неделя») из меню убраны — постановку и приёмку
  // теперь ведёт «Монтаж». Сами страницы на месте и открываются по адресу.
  // «Темы» руководителя ушли в доску «Монтажа» 06.10.2026: тема теперь и есть
  // то, что ставится монтажёру, отдельного экрана для неё нет.
  { path: ROUTES.MONTAGE, label: 'Монтаж', match: ['/montage'], scope: 'pipeline', roles: ['head', 'content_maker'] },
  { path: ROUTES.MY_TASKS, label: 'Мои задачи', match: ['/my-tasks'], scope: 'pipeline', roles: ['editor'] },
  { path: ROUTES.VIDEOS, label: 'Видео', match: ['/videos'], scope: 'pipeline', roles: ['head', 'content_maker', 'editor'] },
  // Раздающий (Редакция) берёт вышедшие ролики B2G — доски и модерации у него нет.
  { path: ROUTES.TAKES, label: 'Ролики B2G', match: ['/takes'], scope: 'pipeline', roles: ['distributor'] },
  // Учёт сделанного раздающим и отчёт по нему руководителю (25.10.2026).
  { path: ROUTES.WORK, label: 'Отработано', match: ['/work'], scope: 'pipeline', roles: ['distributor', 'head'] },
  { path: ROUTES.MODERATION, label: 'Модерация роликов', match: ['/moderation'], scope: 'pipeline', roles: ['moderator'] },
  { path: ROUTES.DIVISION, label: 'Отделение', match: ['/division'], scope: 'pipeline', roles: ['head'] },
  // Сетевой блок — ровно тот, что стоит на бою. «Комментарии» сюда не
  // возвращаются: 26.09.2026 их сознательно сделали вкладкой «Публикаций»,
  // и отдельный пункт был бы новинкой для тех, кто «Монтажа» не касается.
  { path: ROUTES.STATS, label: 'Статистика', match: ['/stats', '/analytics', '/accounts-stats'], scope: 'network' },
  { path: ROUTES.PUBLICATIONS, label: 'Публикации', match: ['/publications', '/all-publications', '/posts', '/reels'], scope: 'network' },
  { path: ROUTES.ACCOUNTS, label: 'Аккаунты', match: ['/accounts', '/templates'], scope: 'network' },
] as const;

export type NavSection = (typeof NAV_SECTIONS)[number];

/** Роли, которым аккаунты сети не показываем вовсе. */
const PIPELINE_ONLY: readonly string[] = ['editor', 'moderator'];

/**
 * Какие разделы показать этому человеку.
 *
 * Раздел про аккаунты прячется, только когда все роли человека — из числа
 * тех, кому сеть не нужна. У тех, кого в отделения ещё не завели, меню остаётся
 * прежним: выкатка отделений не должна молча отобрать доступ у работающих.
 * Ограничение живёт на сервере, меню лишь не предлагает бесполезное.
 */
export function visibleNavSections(
  { isAdmin, divisionRoles }: { isAdmin: boolean; divisionRoles: readonly string[] },
): NavSection[] {
  if (isAdmin) return [...NAV_SECTIONS];

  const hasPipelineRole = divisionRoles.length > 0;
  const networkHidden = hasPipelineRole && divisionRoles.every((r) => PIPELINE_ONLY.includes(r));

  return NAV_SECTIONS.filter((section) => {
    if (section.scope === 'network') return !networkHidden;
    return (section as { roles?: readonly string[] }).roles?.some((r) => divisionRoles.includes(r)) ?? false;
  });
}

export interface NavGroup {
  /** Подпись над блоком или `null` — блок один, подписывать нечего. */
  caption: string | null;
  items: NavSection[];
}

/**
 * Разделы, разложенные по блокам с подписями.
 *
 * Блока два, и граница между ними не декоративная: слева от неё то, чем
 * InstaFarm был до конвейера — аккаунты сети и всё вокруг них, — справа то,
 * что добавил «Монтаж». Человеку, работающему только с аккаунтами, новый слой
 * не должен мозолить глаза, а монтажёру незачем видеть статистику сети.
 *
 * Подписи появляются, только когда блоков больше одного. У нынешних
 * пользователей виден ровно один блок — и меню у них остаётся буква в букву
 * прежним, без заголовка, которого раньше не было.
 */
export function groupNavSections(sections: readonly NavSection[]): NavGroup[] {
  const networkOrder = [ROUTES.PUBLICATIONS, ROUTES.STATS, ROUTES.ACCOUNTS];
  const order = [
    { scope: 'network', caption: 'Основное' },
    { scope: 'pipeline', caption: 'Производство' },
  ] as const;

  const groups = order
    .map(({ scope, caption }) => ({
      caption,
      items: sections.filter((s) => s.scope === scope).sort((a, b) =>
        scope === 'network' ? networkOrder.indexOf(a.path) - networkOrder.indexOf(b.path) : 0),
    }))
    .filter((group) => group.items.length > 0);

  return groups.length > 1 ? groups : groups.map((group) => ({ ...group, caption: null }));
}

/**
 * Разделы одним списком в порядке сайдбара — для таб-бара и перехода с «/».
 * Раньше таб-бар и корень брали сырой порядок NAV_SECTIONS, а сайдбар —
 * отсортированный, и первая вкладка внизу не совпадала с первой строкой меню.
 */
export function orderedNavSections(sections: readonly NavSection[]): NavSection[] {
  return groupNavSections(sections).flatMap((group) => group.items);
}

/** Последний открытый раздел — с него начинается следующий заход на «/». */
const LAST_SECTION_KEY = 'if:remembered:nav:last-section';

export function rememberSection(pathname: string): void {
  const section = NAV_SECTIONS.find((s) => isSectionActive(pathname, s.match, (s as { end?: boolean }).end));
  if (!section) return;
  try {
    localStorage.setItem(LAST_SECTION_KEY, JSON.stringify(section.path));
  } catch {
    // Нет хранилища — начнём с первого раздела.
  }
}

function lastSection(): string | null {
  try {
    const raw = localStorage.getItem(LAST_SECTION_KEY);
    return raw ? (JSON.parse(raw) as string) : null;
  } catch {
    return null;
  }
}

/**
 * Куда вести с «/»: в последний открытый раздел, если он человеку ещё виден,
 * иначе — в первый пункт меню по его роли.
 */
export function homePath(sections: readonly NavSection[], last: string | null = lastSection()): string {
  const ordered = orderedNavSections(sections);
  if (last && ordered.some((s) => s.path === last)) return last;
  return ordered[0]?.path ?? ROUTES.STATS;
}

/**
 * Активен ли раздел для текущего pathname.
 *
 * `end` нужен там, где один раздел лежит внутри другого: «/content» —
 * задачи, «/content/review» — проверка, и по префиксу подсветились бы оба.
 */
export function isSectionActive(
  pathname: string, match: readonly string[], end = false,
): boolean {
  if (end) return match.some((path) => pathname === path);
  return match.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
